// Utility to extract product name from canonical URL or productURL
export const extractProductNameFromUrl = (url) => {
  if (typeof url !== 'string') return '';
  // Try '/p/cabinet-seller/<product-name>/<itemzid>'
  let match = url.match(/\/p\/cabinet-seller\/([^/]+)\/[0-9]+/);
  if (match && match[1]) {
    return match[1].toLowerCase();
  }
  // Try '/p/<product-name>/'
  match = url.match(/\/p\/([^/]+)\//);
  if (match && match[1]) {
    return match[1].toLowerCase();
  }
  return '';
};